/**
 * @description Categories of order items
 */
export var Categories;

(function (Categories) {
  Categories["MEDICATION"] = "medication_orders";
  Categories["THERAPY"] = "therapies";
  Categories["EXAMINATION"] = "examinations";
  Categories["TREATMENT"] = "treatments";
  Categories["DIETARY_SUPPLEMENT"] = "dietary_supplements";
  Categories["OUTPATIENT_SERVICE"] = "outpatient_services";
  Categories["WELLNESS_PROGRAM"] = "wellness_programs";
  Categories["OFFSET"] = "offset_order_items";
})(Categories || (Categories = {}));

export var PaymentType;

(function (PaymentType) {
  PaymentType["PAY_IN_FULL"] = "pay_in_full";
  PaymentType["PAY_IN_INSTALLMENTS"] = "pay_in_installments";
})(PaymentType || (PaymentType = {}));

export var TransactionType;

(function (TransactionType) {
  TransactionType["PAYMENT"] = "payment";
  TransactionType["REFUND"] = "refund";
})(TransactionType || (TransactionType = {}));

export var OrderType;

(function (OrderType) {
  OrderType["MEDICAL_PRESCRIPTION"] = "medical_prescription";
  OrderType["NUTRITION_PLANNING"] = "nutrition_planning";
  OrderType["OTHERS"] = "others";
})(OrderType || (OrderType = {}));